module.exports = __webpack_public_path__ + "img/EE10539549.7469a864.png";